import { useIntl, FormattedMessage } from 'react-intl';
import { ReactNode, JSX } from 'react';
import { cx } from '@emotion/css';

import { useStyles } from './about-section.styles';
import { ContentWrapper } from '../../../common/content-wrapper';
import { SectionTitle } from '../../../common/section-title';
import { aboutNumbers, list } from './about.items';
import { SectionLabels } from '../../../../constants/common-constants';
import imgSrc from '../../../../assets/images/about/about.jpg';

export const AboutSection = (): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();
  const id = SectionLabels.about;

  return (
    <section
      className={classes.root}
      data-testid="about"
      aria-labelledby={id}
    >
      <ContentWrapper externalStyles={classes.contentStyles}>
        <SectionTitle
          id={id}
          isLight
          title="about.title"
        />
        <div className={classes.wrapper}>
          <div>
            <img height={390} width={628} className={classes.image} src={imgSrc} alt="" />
          </div>
          <div>
            <h3 className={classes.subtitle}><FormattedMessage id="about.subtitle-1" /></h3>
            <ul className={cx(classes.generalList, classes.list)}>
              {list.map((item, index) => (
                <li className={classes.content} key={index}>
                  {intl.formatMessage(
                    { id: item, defaultMessage: '' },
                    { strong: (chunk: ReactNode) => <strong className={classes.strong}>{chunk}</strong> },
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className={classes.wrapper}>
          <div>
            {['about.content-1', 'about.content-2'].map((item, index) => (
              <p key={index} className={classes.content}>
                {intl.formatMessage(
                  { id: item },
                  { strong: (chunk: ReactNode) => <strong className={classes.strong}>{chunk}</strong> },
                )}
              </p>
            ))}
          </div>
          <div>
            <p className={classes.content}>{intl.formatMessage(
              { id: 'about.content-3' },
              { strong: (chunk: ReactNode) => <strong className={classes.strong}>{chunk}</strong> },
            )}</p>
          </div>
        </div>
        <ul className={cx(classes.generalList, classes.dataList)}>
          {aboutNumbers.map((item, index) => (
            <li key={index} className={classes.dataListItem}>
              <span className={classes.emphasis}>{item.title}</span>
              <span className={classes.bottom}><FormattedMessage id={item.content} /></span>
            </li>
          ))}
        </ul>
      </ContentWrapper>
    </section>
  );
};
